module.exports = __webpack_public_path__ + "assets/img/mobile-logo.164d92de.jpg";